import { LabelKey } from '@shared/models';
import { ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const filterColorsSerializer = (filters: ElasticSearchResponse<unknown>): LabelKey[] => {
  return (
    filters.aggregations?.visuels.noms_de_filtres.buckets.map((filter) => ({
      key: filter.key,
      label: filter.key,
    })) ?? []
  );
};
